package amazon.lastmile.inject

import app.nestbridge.feature.invitations.presentation.InvitationConfirmationPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationConfirmationPresenterFactory::class)
public interface AppNestbridgeFeatureInvitationsPresentationInvitationConfirmationPresenterFactory {
  @Provides
  @IntoSet
  public fun provideInvitationConfirmationPresenterFactoryFactoryMultibinding(invitationConfirmationPresenterFactory: InvitationConfirmationPresenterFactory): Presenter.Factory = invitationConfirmationPresenterFactory
}
